<template>
  <el-dropdown @command="handleCommand" trigger="click">
    <el-button icon="el-icon-more" size="mini" type="plain"></el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="editAction">
        <i class="el-icon-edit-outline"></i> {{ $ml.get('edit') }}
      </el-dropdown-item>
      <el-dropdown-item command="removeAction">
        <i class="el-icon-delete"></i> {{ $ml.get('remove') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  methods: {
    handleCommand(command) {
      if (command === 'editAction') {
        this.params.props.editAction(this.params)
      } else if (command === 'removeAction') {
        this.params.props.removeAction(this.params)
      }
    }
  }
}
</script>